export const siteConfig = {
  brand: {
    name: "Shiksha Guide",
    tagline: "Learn AI. Work Smarter. Grow Faster.",
    domain: "shikshaguide.in",
    email: "chirag@shikshaguide.in",
    phone: "+91 99246 19959",
    whatsapp: "919924619959",
    whatsappLink:
      "https://wa.me/919924619959?text=Hi%20Chirag%2C%20I%20would%20like%20to%20know%20more%20about%20your%20AI%20services%20and%20workshops%20in%20Surat.",
    whatsappRegistrationLink:
      "https://wa.me/919924619959?text=Hi%20Chirag%2C%20I%20want%20to%20register%20for%20an%20upcoming%20AI%20workshop.%20My%20name%20is%20___%20and%20my%20mobile%20number%20is%20___.",
    whatsappSuccessLink:
      "https://wa.me/919924619959?text=Hi%20Chirag%2C%20I%20just%20registered%20for%20the%20Feb%2028%2C%202026%20AI%20workshop.%20My%20name%20is%20___%20and%20my%20mobile%20number%20is%20___.",
    founder: "Chirag Doshi",
    linkedIn: "https://www.linkedin.com/company/shiksha-guide",
    instagram: "https://www.instagram.com/shikshaguide",
    youtube: "https://www.youtube.com/@shikshaguide",
  },

  office: {
    floor: "C6, 1812",
    building: "The Junomoneta Tower",
    area: "Opp. Pal RTO, Pal Gam",
    city: "Surat, Gujarat – 395009",
    hours: "Monday–Saturday: 10:30 AM – 7:30 PM",
    sunday: "Sunday: By Appointment Only",
    // Embed uses the verified Shiksha Guide Place CID (from Google Business Profile)
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.9!2d72.8253!3d21.1965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04de7e8e3d13f:0xac38f0745ffdf0ff!2sShiksha+Guide!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
    // Directions open the verified Shiksha Guide listing by Place CID
    directionsUrl:
      "https://www.google.com/maps/place/?q=place_id:ChIJP9HjyOdE4DsR__D9X3TwOKw",
  },

  hero: {
    headline: "Practical AI for Business Owners & Professionals",
    subtext:
      "Learn how to manage your digital presence, communication systems, content creation, and AI-supported workflows through structured training and customized AI solutions.",
    ctaPrimary: "Explore SG Smart Switch",
    ctaPrimaryLink: "/services/sg-smart-switch",
    ctaSecondary: "Explore SG Sakha",
    ctaSecondaryLink: "/services/sg-sakha",
    trustChips: ["Practical", "Hands-on", "Structured", "Outcome-Driven"],
  },

  featureCards: [
    {
      title: "Structured Application",
      description:
        "We focus on applying AI tools to real business and professional workflows in a clear and usable way.",
    },
    {
      title: "Guided Implementation",
      description:
        "Every session follows a step-by-step approach so participants understand not just the tool, but how to use it correctly.",
    },
    {
      title: "Continuous Learning",
      description:
        "AI evolves rapidly. We encourage practical thinking and ongoing improvement beyond a single workshop.",
    },
  ],

  whoIsItFor: [
    { label: "Business Owners", description: "Use AI to improve systems, strengthen decision-making, and build structured digital visibility." },
    { label: "Working Professionals", description: "Reduce repetitive work, improve productivity, and integrate AI into daily workflows." },
    { label: "Corporate & Institutional Teams", description: "Enable teams with practical AI training designed for real implementation." },
    { label: "Students", description: "Build digital awareness and understand how AI can support learning and future-ready skills." },
  ],

  upcomingWorkshop: null,

  workshops: [],

  pastWorkshops: [
    {
      id: "practical-ai-280226",
      title: "Practical AI Workshop",
      date: "February 28, 2026",
      duration: "60 Minutes",
      conductedBy: "Shiksha Guide",
      summary:
        "A hands-on introductory workshop designed to help business owners understand practical uses of AI tools in business operations.",
    },
  ],

  segments: [
    { label: "Business Owners" },
    { label: "Working Professionals" },
    { label: "Students" },
    { label: "Marketing Teams" },
    { label: "Traders" },
    { label: "Corporate Teams" },
  ],

  aboutShikshaGuide: {
    title: "About Shiksha Guide",
    description:
      "Shiksha Guide was founded by Chirag Doshi in 2024 with a clear objective — to build structured clarity in learning and professional growth. Building on Chirag's professional journey since 2011, the platform delivers structured AI workshops, digital visibility programs, career clarity conversations, and smart technology training designed for real-world application.",
    foundation: "Clarity. Structure. Implementation.",
  },

  visionMission: {
    vision:
      "To enable structured and responsible adoption of AI and new-generation technology across individuals and organisations.",
    mission:
      "To deliver practical training programs and workshops that help participants move from awareness to real implementation using AI and smart tools.",
  },

  whyChoose: [
    { title: "Practical, Not Theoretical", description: "Every session is hands-on with real tools and real use cases" },
    { title: "Business-First Context", description: "Designed for real business use — practical, implementation-focused, and outcome-driven." },
    { title: "Small Batch Sizes", description: "Personalised attention and interactive learning" },
    { title: "Certified AI Trainer", description: "Learn from Chirag Doshi with credentials from IIT Bombay, Microsoft, and more" },
  ],

  aboutChirag: {
    title: "Chirag Doshi",
    subtitle: "Founder & Chief Strategy Officer",
    description:
      "Chirag Doshi is the Founder and Chief Strategy Officer of Shiksha Guide. His work sits at the intersection of AI & Business Enablement and Career Clarity & Education Pathways, supporting business owners, working professionals, students and parents through structured decision-making.",
    background:
      "His professional journey began in 2011 in career and education guidance. Shiksha Guide was founded in 2024 as a clarity-driven platform that brings practical AI adoption, business systems, career clarity, education pathways, and study abroad, visa and permit support under one structured approach.",
    approach: ["Clarity", "Structure", "Right Tool", "Implementation", "Review"],
  },

  aiCredentials: [
    {
      title: "Generative AI Foundations Certificate Program",
      issuer: "upGrad (in collaboration with Microsoft)",
      date: "September 25, 2025",
      uid: "2SpNox501dhGtFMZ",
      tags: ["Generative AI", "Microsoft"],
      image: "/certificates/upgrad-microsoft-genai.jpg",
    },
    {
      title: "AI Tools & ChatGPT Workshop",
      issuer: "be10x",
      date: "February 4, 2026",
      tags: ["AI Tools", "ChatGPT"],
      image: "/certificates/be10x-certificate.jpg",
    },
    {
      title: "Agentic AI Workshop",
      issuer: "360DigiTMG",
      date: "January 10, 2026",
      tags: ["Agentic AI"],
      image: "/certificates/360digitmg-agentic-ai.jpg",
    },
    {
      title: "Become an Advanced AI Marketer in 2026",
      issuer: "WsCube Tech",
      date: "January 7, 2026",
      uid: "WS/2026/M/36200",
      tags: ["AI Marketing"],
      image: "/certificates/wscube-tech-ai-marketer.jpg",
    },
    {
      title: "Generative AI Masterclass",
      issuer: "LetsUpgrade x ITM Skills University",
      date: "December 13–14, 2025",
      tags: ["Generative AI"],
      image: "/certificates/letsupgrade-genai-masterclass.jpg",
    },
    {
      title: "Generative AI Mastermind",
      issuer: "Outskill",
      date: "2025",
      tags: ["Generative AI"],
      image: "/certificates/outskill-genai-mastermind.jpg",
    },
  ],

  contactForm: {
    personas: [
      "Student",
      "Parent",
      "Working Professional",
      "Business Owner",
      "Institution Representative",
    ],
    topics: [
      "AI & Business Enablement",
      "Shiksha Guide Smart Switch",
      "AI Workshop",
      "AI Adoption Consulting",
      "Digital Strategy & Business Systems Consulting",
      "Workflow Design",
      "Business Workflow Systems",
      "Digital Presence Guidance",
      "Productivity Systems",
      "Productivity & Execution Support",
      "Content & Presentation Training",
      "SG Sakha",
      "Career Counselling & Clarity",
      "DMIT-Based Understanding",
      "SG Focus Planner",
      "Course / Stream Selection",
      "India Admissions Support",
      "Study Abroad Guidance",
      "Canada Study Pathway",
      "Visitor Visa / Dependent Visa Support",
      "SG Elevate",
      "General Enquiry / Other",
    ],

    hearAboutOptions: [
      "Google Search",
      "Google Business Profile",
      "Instagram",
      "LinkedIn",
      "Facebook",
      "WhatsApp",
      "Referral",
      "Workshop / Event",
      "Existing Client / Student",
      "Other",
    ],
    consentNote:
      "By submitting, you agree to be contacted by Shiksha Guide regarding your enquiry.",
  },

  faq: [
    {
      q: "Do I need any prior knowledge or technical background?",
      a: "No prior knowledge is required. Our workshops are designed for non-technical audiences — no coding, no jargon. If you can use a smartphone, you're ready to attend.",
    },
    {
      q: "Who should attend this workshop?",
      a: "This workshop is designed for business owners, working professionals, students, marketing teams, and anyone who wants to understand and apply AI tools in real work. If you're curious about AI and want clarity on how to use it practically, this is for you.",
    },
    {
      q: "What will I be able to do after attending?",
      a: "You will leave with working knowledge of AI tools, structured prompting techniques, and a practical workflow you can apply to your own work or business — starting the next day.",
    },
    {
      q: "What is the format of the workshop?",
      a: "It is a live, in-person, hands-on session. You will work with real AI tools during the session, follow structured demonstrations, and participate in guided exercises with dedicated Q&A time.",
    },
    {
      q: "What device should I bring?",
      a: "Bring a fully charged laptop with internet access. Wi-Fi and charging points are available at the venue. A smartphone can be used as a backup but a laptop is strongly recommended for the best experience.",
    },
    {
      q: "How will I receive venue details and confirmation?",
      a: "Upon registration, you will be added to a dedicated WhatsApp group where all details — including the confirmed venue address, preparation checklist, and session instructions — will be shared.",
    },
    {
      q: "What is included in my registration?",
      a: "Your registration includes hands-on training, printed reference materials, refreshments, a certificate of completion, and access to our ongoing community WhatsApp group.",
    },
    {
      q: "Do participants receive a certificate?",
      a: "Yes. Every participant who attends and completes the workshop receives a Shiksha Guide certificate of completion.",
    },
    {
      q: "Can I transfer my registration to someone else?",
      a: "Yes. If you are unable to attend, please contact us on WhatsApp at least three days before the workshop date to arrange a transfer.",
    },
  ],

  testimonials: [
    {
      name: "Rahul M.",
      role: "Business Owner",
      text: "This workshop helped me apply AI tools directly to my business operations. Practical and immediately useful.",
    },
    {
      name: "Priya S.",
      role: "Working Professional",
      text: "Clear explanation. No jargon. I could apply the learning immediately to my daily work.",
    },
    {
      name: "Amit P.",
      role: "Finance Professional",
      text: "The session showed exactly how AI can improve research and client work. Highly structured and easy to follow.",
    },
  ],

  stats: [
    { number: "500+", label: "Professionals Trained" },
    { number: "50+", label: "Workshops Conducted" },
    { number: "4.8/5", label: "Average Participant Rating" },
    { number: "100%", label: "Practical Learning Focus" },
  ],

  /**
   * Smart Switch batch single source of truth.
   * Update ONLY this block when batches change. All pages read from here.
   * `ongoing`  = currently running batch (status badge: "Ongoing")
   * `next`     = confirmed next batch month; dates and registration details may be pending
   */
  smartSwitch: {
    ongoing: {
      name: "October 2026",
      label: "October 2026 Batch",
      status: "Currently Running" as const,
      startedLabel: "October 2026",
    },
    next: {
      name: "December 2026",
      label: "December 2026 Batch",
      status: "Upcoming · Start date to be announced" as const,
      startDate: "December 2026",
      startDateLabel: "December 2026 · Orientation on Saturday, 5 December 2026. Main batch start date to be announced.",
      seatsLabel: "Batch details to be announced",
      enquiryHref: "/enquiry?service=Shiksha%20Guide%20Smart%20Switch&batch=December%202026%20Batch",
      applyHref: "/register/sg-smart-switch-october-2026",
    },
  },

  footer: {
    copyright: `© ${new Date().getFullYear()} Shiksha Guide. All rights reserved.`,
  },
};

export type SiteConfig = typeof siteConfig;
